import {
  SET_SUBSCRIBED_INSTITUTES,
  SET_SUBSCRIPTION_RENEWAL_INSTITUTES,
  SET_SELECTED_INSTITUTE,
  SET_LOADING,
  SET_ERROR,
  SET_TOTAL_COLLEGE_COUNT,
  SET_ACTIVE_ASSESSMENT_COUNT,
  SET_ASSESSMENT_SENT_COUNT,
  SET_ASSESSMENT_COMPLETED_COUNT,
  SET_SUBSCRIBED_INSTITUTES_SUBSCRIBED_COUNT,
  SET_SUBSCRIBED_INSTITUTES_TRIAL_COUNT,
  SET_SUBSCRIPTION_RENEWAL_SUBSCRIBED_COUNT,
  SET_SUBSCRIPTION_RENEWAL_TRIAL_COUNT,
  SET_SUBSCRIBED_INSTITUTES_PAGINATION,
  SET_SUBSCRIPTION_RENEWAL_PAGINATION,
  SET_FILTERS,
  UPDATE_PAGE,
  RESET_FILTERS,
  RESET_STATE,
  SET_INSTITUTES_STATES,
  SET_INSTITUTES_CITIES,
  SET_INSTITUTES_BY_CITY,
  SET_ASSESSMENT_BY_INSTITUTE,
  SET_DEGREE_SEARCH_RESULTS,
  SET_DEGREE_SEARCH_LOADING,
  SET_DEGREE_SEARCH_ERROR,
  SET_DEGREE_SELECTION,
  SET_RECENT_ACTIVITY_LOGS,
  SET_ACTIVE_ASSESSMENTS,
  SET_COMPLETED_ASSESSMENTS,
  SET_ACTIVE_ASSESSMENTS_PAGINATION,
  SET_COMPLETED_ASSESSMENTS_PAGINATION,
  SET_ACTIVE_ASSESSMENTS_METRICS,
  SET_COMPLETED_ASSESSMENTS_METRICS,
  SET_STUDENT_DATA_SENT,
  SET_STUDENT_DATA_PENDING,
  SET_STUDENT_DATA_IN_PROGRESS,
  SET_STUDENT_DATA_DROPPED_OFF,
  SET_STUDENT_DATA_COMPLETED,
  SET_STUDENT_DATA_LOADING,
  SET_STUDENT_DATA_PAGINATION,
  SET_ASSESSMENT_CREATION_DATA,
  ADD_BULK_UPLOAD_DATA,
  REMOVE_ASSESSMENT,
  CLEAR_ASSESSMENT_CREATION_DATA,
  SET_SUBSCRIPTION_STATES,
  SET_SUBSCRIPTION_CITIES,
  SET_SUBSCRIPTION_INSTITUTES,
  ASSIGN_SUBSCRIPTION_REQUEST,
  ASSIGN_SUBSCRIPTION_SUCCESS,
  ASSIGN_SUBSCRIPTION_FAILURE,
  // Media-related action types
  FETCH_MEDIA_KEYS_REQUEST,
  FETCH_MEDIA_KEYS_SUCCESS,
  FETCH_MEDIA_KEYS_FAILURE,
  FETCH_MEDIA_URLS_REQUEST,
  FETCH_MEDIA_URLS_SUCCESS,
  FETCH_MEDIA_URLS_FAILURE,
  RESET_MEDIA_STATE,
  // PDF Report-related action types
  CHECK_REPORT_AVAILABILITY_REQUEST,
  CHECK_REPORT_AVAILABILITY_SUCCESS,
  CHECK_REPORT_AVAILABILITY_FAILURE,
  // Assessment states, TPO student list, charts, and chart filters
  FETCH_ASSESSMENT_STATES_REQUEST,
  FETCH_ASSESSMENT_STATES_SUCCESS,
  FETCH_ASSESSMENT_STATES_FAILURE,
  FETCH_TPO_STUDENT_LIST_REQUEST,
  FETCH_TPO_STUDENT_LIST_SUCCESS,
  FETCH_TPO_STUDENT_LIST_FAILURE,
  FETCH_ASSESSMENT_CHARTS_REQUEST,
  FETCH_ASSESSMENT_CHARTS_SUCCESS,
  FETCH_ASSESSMENT_CHARTS_FAILURE,
  SET_CHART_FILTERS,
  CLEAR_CHART_FILTERS,
  SET_CORPORATE_COMPANIES,
  SET_CORPORATE_STATES,
  SET_CORPORATE_CITIES,
  SET_ASSESSMENT_CORPORATE_STATES,
  SET_ASSESSMENT_CORPORATE_CITIES,
  SET_ASSESSMENT_CORPORATE_COMPANIES,
  SET_ASSESSMENT_INFO,
  SET_DELIVERY_FUNNEL,
  FETCH_APTITUDE_TOPICS_REQUEST,
  FETCH_APTITUDE_TOPICS_SUCCESS,
  FETCH_APTITUDE_TOPICS_FAILURE,
  FETCH_APTITUDE_CONFIG_REQUEST,
  FETCH_APTITUDE_CONFIG_SUCCESS,
  FETCH_APTITUDE_CONFIG_FAILURE,
  SCHEDULE_ASSESSMENTS_REQUEST,
  SCHEDULE_ASSESSMENTS_SUCCESS,
  SCHEDULE_ASSESSMENTS_FAILURE,
  UPDATE_SCHEDULE_ASSESSMENT_REQUEST,
  UPDATE_SCHEDULE_ASSESSMENT_SUCCESS,
  UPDATE_SCHEDULE_ASSESSMENT_FAILURE,
  GET_SCHEDULE_ASSESSMENT_REQUEST,
  GET_SCHEDULE_ASSESSMENT_SUCCESS,
  GET_SCHEDULE_ASSESSMENT_FAILURE,
  GENERATE_ROLE_BASED_QUESTIONS_REQUEST,
  GENERATE_ROLE_BASED_QUESTIONS_SUCCESS,
  GENERATE_ROLE_BASED_QUESTIONS_FAILURE,
  GENERATE_HINGLISH_QUESTIONS_REQUEST,
  GENERATE_HINGLISH_QUESTIONS_SUCCESS,
  GENERATE_HINGLISH_QUESTIONS_FAILURE,
  ASSIGN_ROLE_BASED_ASSESSMENT_REQUEST,
  ASSIGN_ROLE_BASED_ASSESSMENT_SUCCESS,
  ASSIGN_ROLE_BASED_ASSESSMENT_FAILURE,
  RECALCULATE_ASSESSMENT_REQUEST,
  RECALCULATE_ASSESSMENT_SUCCESS,
  RECALCULATE_ASSESSMENT_FAILURE,
    FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST,
  FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS,
  FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE,
} from './actions'
const INITIAL_STATE = {
  // Main data arrays
  subscribedInstitutes: [],
  subscriptionRenewalInstitutes: [],
  selectedInstitute: null,

  // Common states
  loading: false,
  error: null,

  // Common counts
  totalCollegeCount: 0,
  activeAssessmentCount: 0,
  assessmentSentCount: 0,
  assessmentCompletedCount: 0,

  // Assessment filters
  assessmentFilters: {
    passingYear: '',
    Domain: '',
    degree: '',
    dept: '',
    specialization: '',
  },

  assessmentCreationData: [],
  assessmentInfo: null,
  deliveryFunnel: null,
  // Institute data arrays
  instituteDomain: [],
  instituteDegree: [],
  instituteDepartment: [],
  instituteSpecialization: [],

  activeAssessments: [],
  // Active assessments pagination
  activeAssessmentsPagination: {
    page: 0,
    limit: 10,
    totalPages: 1,
    totalItems: 0,
    currentCount: 0,
  },
  // Active assessments metrics
  activeAssessmentsMetrics: {
    total: 0,
    completed: 0,
    pending: 0,
  },
  aptitudeTopics: {
    data: [],
    loading: false,
    error: null,
  },
  aptitudeConfig: {
    data: {},
    loading: false,
    error: null,
  },
  // Completed assessments array
  completedAssessments: [],
  // Completed assessments pagination
  completedAssessmentsPagination: {
    page: 0,
    limit: 10,
    totalPages: 1,
    totalItems: 0,
    currentCount: 0,
  },
  // Completed assessments metrics
  completedAssessmentsMetrics: {
    total: 0,
    completedOnTime: 0,
    completedLate: 0,
  },

  studentData: {
    sent: [],
    pending: [],
    inProgress: [],
    droppedOff: [],
    completed: [],
  },
  studentDataLoading: false,
  studentDataPagination: { totalCount: 0, currentPage: 1, totalPages: 0, limit: 10 },

  // Subscribed Institutes metrics
  subscribedInstitutesMetrics: {
    subscribedCount: 0,
    trialCount: 0,
    totalCount: 0,
  },

  // Subscription Renewal metrics
  subscriptionRenewalMetrics: {
    subscribedCount: 0,
    trialCount: 0,
    totalCount: 0,
  },

  // Subscribed Institutes pagination
  subscribedInstitutesPagination: {
    page: 0,
    limit: 10,
    totalPages: 1,
    totalItems: 0,
    currentCount: 0,
  },

  // Subscription Renewal pagination
  subscriptionRenewalPagination: {
    page: 0,
    limit: 10,
    totalPages: 1,
    totalItems: 0,
    currentCount: 0,
  },

  // Common filters
  // Default sort = newest-created first. Backend maps order 'createdAt' to
  // COALESCE(audit.createdat, start_time) — see admin-node getActiveAssessments.
  filters: {
    searchBy: '',
    order: 'createdAt',
    sort: 'desc',
    type_name: '',
    isTrial: false,
    isSubscribed: false,
    pageNo: 0,
    pageLimit: 10,
    states: [], // Array of selected states
    cities: [], // Array of selected cities
  },

  // Create Assessment Filters
  institutesState: [],
  institutesCity: [],
  institutesName: [],
  subscribedAssessment: [],
  assessmentCorporateStates: [],
  assessmentCorporateCities: [],
  assessmentCorporateCompanies: [],

  // Degree Search
  degreeSearch: {
    results: [],
    loading: false,
    error: null,
  },

  subscriptionStates: [],
  subscriptionCities: [],
  subscriptionInstitutes: [],
  corporateStates: [],
  corporateCities: [],
  companies: [],
  subscriptionAssignLoading: false,
  subscriptionAssignError: null,
  subscriptionAssignSuccess: null,

  resentActivityLog: [],
  isScheduling: false,
  scheduleError: null,
  scheduleSuccessMessage: '',

  roleBasedQuestions: {
    loading: false,
    data: null,
    error: null,
  },
  roleBasedAssessment: {
    loading: false,
    data: null,
    error: null,
  },

  specificAssessmentStudentList: {
    students: [],
    totalCount: 0,
    loading: false,
    error: null,
  },

  // TPO Dashboard Student List
  tpoStudentList: [],
  tpoStudentListPagination: {
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
  },
  tpoStudentListLoading: false,
  tpoStudentListError: null,

  // Chart-based filters
  chartFilters: {
    cefrLevel: null,
    aptitudeLevel: null,
    consistency: null,
    assessmentType: null,
  },

  // Chart data state
  chartData: null,
  chartLoading: false,
  chartError: null,
};

export const SubscribedInstitutes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SUBSCRIBED_INSTITUTES:
      return {
        ...state,
        subscribedInstitutes: action.data.data.map(si => ({
          subscription_id: si.subscription_id,
          institute_id: si.institute_id,
          tokens_used: si.tokens_used,
          token_limit: si.token_limit,
          subscription_type: si.subscription_type,
          start_date: si.start_date,
          end_date: si.end_date,
          campus_name: si.campus_name,
          campus_logo_url: si.campus_logo_url,
          city: si.city,
          state: si.state,
          contact_email: si.contact_email,
          contact_number: si.contact_number,
          degrees: si.degreeDepartment || [],
          degreeDepartment: si.degreeDepartment || [],
          degreeDepartmentCount: si.degreeDepartmentCount || 0,
          hasMoreDegreeDepartments: si.hasMoreDegreeDepartments || false,
        })),
        subscribedInstitutesMetrics: {
          subscribedCount: action.data.subscribedCount,
          trialCount: action.data.trialCount,
          totalCount: action.data.count,
        },
        subscribedInstitutesPagination: {
          ...state.subscribedInstitutesPagination,
          page: parseInt(action.data.page),
          limit: parseInt(action.data.limit),
          totalItems: action.data.count,
          currentCount: action.data.currentCount,
          totalPages: parseInt(action.data.totalPages),
          stateCityPairs: action.data.stateCityPairs,
        },
        error: null,
      }
    case SET_ASSESSMENT_INFO:
      return {
        ...state,
        assessmentInfo: action.assessmentInfo,
      }
    case SET_DELIVERY_FUNNEL:
      return {
        ...state,
        deliveryFunnel: action.deliveryFunnel,
      }
    case SET_SUBSCRIPTION_RENEWAL_INSTITUTES:
      return {
        ...state,
        subscriptionRenewalInstitutes: action.data.data.map(si => ({
          subscription_id: si.subscription_id,
          institute_id: si.institute_id,
          tokens_used: si.tokens_used,
          token_limit: si.token_limit,
          subscription_type: si.subscription_type,
          start_date: si.start_date,
          end_date: si.end_date,
          campus_name: si.campus_name,
          campus_logo_url: si.campus_logo_url,
          city: si.city,
          state: si.state,
          contact_email: si.contact_email,
          contact_number: si.contact_number,
          degrees: si.degreeDepartment || [],
          degreeDepartment: si.degreeDepartment || [],
          degreeDepartmentCount: si.degreeDepartmentCount || 0,
          hasMoreDegreeDepartments: si.hasMoreDegreeDepartments || false,
        })),
        subscriptionRenewalMetrics: {
          subscribedCount: action.data.subscribedCount,
          trialCount: action.data.trialCount,
          totalCount: action.data.count,
        },
        subscriptionRenewalPagination: {
          ...state.subscriptionRenewalPagination,
          page: parseInt(action.data.page),
          limit: parseInt(action.data.limit),
          totalItems: action.data.count,
          currentCount: action.data.currentCount,
          totalPages: parseInt(action.data.totalPages),
          stateCityPairs: action.data.stateCityPairs,
        },
      }

    case UPDATE_PAGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          pageNo: action.page,
        },
      }
    case FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST:
      return {
        ...state,
        specificAssessmentStudentList: {
          ...state.specificAssessmentStudentList,
          loading: true,
          error: null,
        },
      };

    case FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        specificAssessmentStudentList: {
          loading: false,
          students: action.payload.students,
          totalCount: action.payload.totalCount,
          error: null,
        },
      };

    case FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE:
      return {
        ...state,
        specificAssessmentStudentList: {
          ...state.specificAssessmentStudentList,
          loading: false,
          error: action.payload,
        },
      };
    case SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
          pageNo: action.filters.pageNo ?? 0, // Reset page when filters change
        },
      }

    case RESET_FILTERS:
      return {
        ...state,
        filters: INITIAL_STATE.filters,
      }

    case SET_SELECTED_INSTITUTE:
      return {
        ...state,
        selectedInstitute: action.data,
      }

    case SET_LOADING:
      return {
        ...state,
        loading: action.status,
      }

    case SET_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      }

    case SET_TOTAL_COLLEGE_COUNT:
      return {
        ...state,
        totalCollegeCount: action.count,
      }

    case SET_ACTIVE_ASSESSMENT_COUNT:
      return {
        ...state,
        activeAssessmentCount: action.count,
      }
    case GENERATE_ROLE_BASED_QUESTIONS_REQUEST:
      return {
        ...state,
        roleBasedQuestions: { loading: true, data: null, error: null },
      };
    case GENERATE_ROLE_BASED_QUESTIONS_SUCCESS:
      console.log('Reducer received questions:', action.payload);
      return {
        ...state,
        roleBasedQuestions: { loading: false, data: action.payload, error: null },
      };
    case GENERATE_ROLE_BASED_QUESTIONS_FAILURE:
      return {
        ...state,
        roleBasedQuestions: { loading: false, data: null, error: action.payload },
      };

    case GENERATE_HINGLISH_QUESTIONS_REQUEST:
      return {
        ...state,
        hinglishQuestions: { loading: true, data: null, error: null },
      };
    case GENERATE_HINGLISH_QUESTIONS_SUCCESS:
      return {
        ...state,
        hinglishQuestions: { loading: false, data: action.payload, error: null },
      };
    case GENERATE_HINGLISH_QUESTIONS_FAILURE:
      return {
        ...state,
        hinglishQuestions: { loading: false, data: null, error: action.payload },
      };

    case ASSIGN_ROLE_BASED_ASSESSMENT_REQUEST:
      return {
        ...state,
        roleBasedAssessment: {
          ...state.roleBasedAssessment,
          loading: true,
          error: null,
        },
      };
    case ASSIGN_ROLE_BASED_ASSESSMENT_SUCCESS:
      return {
        ...state,
        roleBasedAssessment: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ASSIGN_ROLE_BASED_ASSESSMENT_FAILURE:
      return {
        ...state,
        roleBasedAssessment: {
          ...state.roleBasedAssessment,
          loading: false,
          error: action.payload,
        },
      };
    case SET_ASSESSMENT_SENT_COUNT:
      return {
        ...state,
        assessmentSentCount: action.count,
        error: null,
      }

    case SET_ASSESSMENT_COMPLETED_COUNT:
      return {
        ...state,
        assessmentCompletedCount: action.count,
        error: null,
      }

    case SET_ACTIVE_ASSESSMENTS:
      return {
        ...state,
        activeAssessments: action.assessments,
        error: null,
      }

    case SET_COMPLETED_ASSESSMENTS:
      return {
        ...state,
        completedAssessments: action.assessments,
        error: null,
      }

    case SET_ACTIVE_ASSESSMENTS_PAGINATION:
      return {
        ...state,
        activeAssessmentsPagination: {
          ...state.activeAssessmentsPagination,
          ...action.pagination,
        },
      }

    case SET_COMPLETED_ASSESSMENTS_PAGINATION:
      return {
        ...state,
        completedAssessmentsPagination: {
          ...state.completedAssessmentsPagination,
          ...action.pagination,
        },
      }

    case SET_ACTIVE_ASSESSMENTS_METRICS:
      return {
        ...state,
        activeAssessmentsMetrics: {
          ...state.activeAssessmentsMetrics,
          ...action.metrics,
        },
      }

    case SET_COMPLETED_ASSESSMENTS_METRICS:
      return {
        ...state,
        completedAssessmentsMetrics: {
          ...state.completedAssessmentsMetrics,
          ...action.metrics,
        },
      }

    case SET_SUBSCRIBED_INSTITUTES_SUBSCRIBED_COUNT:
      return {
        ...state,
        subscribedInstitutesMetrics: {
          ...state.subscribedInstitutesMetrics,
          subscribedCount: action.count,
          totalCount:
            action.count + state.subscribedInstitutesMetrics.trialCount,
        },
      }

    case SET_SUBSCRIBED_INSTITUTES_TRIAL_COUNT:
      return {
        ...state,
        subscribedInstitutesMetrics: {
          ...state.subscribedInstitutesMetrics,
          trialCount: action.count,
          totalCount:
            state.subscribedInstitutesMetrics.subscribedCount + action.count,
        },
      }

    case SET_SUBSCRIPTION_RENEWAL_SUBSCRIBED_COUNT:
      return {
        ...state,
        subscriptionRenewalMetrics: {
          ...state.subscriptionRenewalMetrics,
          subscribedCount: action.count,
          totalCount:
            action.count + state.subscriptionRenewalMetrics.trialCount,
        },
      }

    case SET_SUBSCRIPTION_RENEWAL_TRIAL_COUNT:
      return {
        ...state,
        subscriptionRenewalMetrics: {
          ...state.subscriptionRenewalMetrics,
          trialCount: action.count,
          totalCount:
            state.subscriptionRenewalMetrics.subscribedCount + action.count,
        },
      }

    case SET_SUBSCRIBED_INSTITUTES_PAGINATION:
      return {
        ...state,
        subscribedInstitutesPagination: {
          ...state.subscribedInstitutesPagination,
          ...action.pagination,
        },
      }

    case SET_SUBSCRIPTION_RENEWAL_PAGINATION:
      return {
        ...state,
        subscriptionRenewalPagination: {
          ...state.subscriptionRenewalPagination,
          ...action.pagination,
        },
      }
    case FETCH_APTITUDE_TOPICS_REQUEST:
      return {
        ...state,
        aptitudeTopics: {
          ...state.aptitudeTopics,
          loading: true,
          error: null,
        },
      }

    case FETCH_APTITUDE_TOPICS_SUCCESS:
      return {
        ...state,
        aptitudeTopics: {
          ...state.aptitudeTopics,
          loading: false,
          data: action.payload,
          error: null,
        },
      }

    case FETCH_APTITUDE_TOPICS_FAILURE:
      return {
        ...state,
        aptitudeTopics: {
          ...state.aptitudeTopics,
          loading: false,
          error: action.payload,
        },
      }

    case FETCH_APTITUDE_CONFIG_REQUEST:
      return {
        ...state,
        aptitudeConfig: {
          ...state.aptitudeConfig,
          loading: true,
          error: null,
        },
      }

    case FETCH_APTITUDE_CONFIG_SUCCESS:
      return {
        ...state,
        aptitudeConfig: {
          ...state.aptitudeConfig,
          loading: false,
          data: action.payload,
          error: null,
        },
      }

    case FETCH_APTITUDE_CONFIG_FAILURE:
      return {
        ...state,
        aptitudeConfig: {
          ...state.aptitudeConfig,
          loading: false,
          error: action.payload,
        },
      }

    case SET_INSTITUTES_STATES:
      return {
        ...state,
        institutesState: action.states,
        error: null,
      }

    case SET_INSTITUTES_CITIES:
      return {
        ...state,
        institutesCity: action.cities,
        error: null,
      }

    case SET_INSTITUTES_BY_CITY:
      return {
        ...state,
        institutesName: action.institutes,
        error: null,
      }

    case SET_ASSESSMENT_BY_INSTITUTE:
      return {
        ...state,
        subscribedAssessment: action.assessments,
        error: null,
      }

    case SET_DEGREE_SEARCH_RESULTS:
      return {
        ...state,
        degreeSearch: {
          ...state.degreeSearch,
          results: action.data,
        },
      }

    case SET_DEGREE_SEARCH_LOADING:
      return {
        ...state,
        degreeSearch: {
          ...state.degreeSearch,
          loading: action.status,
        },
      }

    case SET_DEGREE_SEARCH_ERROR:
      return {
        ...state,
        degreeSearch: {
          ...state.degreeSearch,
          error: action.error,
        },
      }

    case SET_DEGREE_SELECTION:
      return {
        ...state,
        degreeSearch: {
          ...state.degreeSearch,
          results: action.data,
        },
      }

    case SET_RECENT_ACTIVITY_LOGS:
      return {
        ...state,
        recentActivityLog: action.logs,
        error: null,
      }

    case SET_STUDENT_DATA_SENT:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          sent: action.students,
        },
      }

    case SET_STUDENT_DATA_PENDING:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          pending: action.students,
        },
      }

    case SET_STUDENT_DATA_IN_PROGRESS:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          inProgress: action.students, // This now includes startedDateTime field
        },
      }

    case SET_STUDENT_DATA_DROPPED_OFF:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          droppedOff: action.students, // This now includes droppedOffDateTime field
        },
      }

    case SET_STUDENT_DATA_COMPLETED:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          completed: action.students,
        },
      }

    case SET_STUDENT_DATA_LOADING:
      return {
        ...state,
        studentDataLoading: action.status,
      }

    case SET_STUDENT_DATA_PAGINATION:
      return {
        ...state,
        studentDataPagination: action.pagination,
      }

    case SET_ASSESSMENT_CREATION_DATA:
      return {
        ...state,
        assessmentCreationData: action.data,
      }

    case ADD_BULK_UPLOAD_DATA:
      return {
        ...state,
        assessmentCreationData: state.assessmentCreationData.map(assessment =>
          assessment.id === action.assessmentId
            ? { ...assessment, bulkUploadData: action.uploadData }
            : assessment
        ),
      }

    case REMOVE_ASSESSMENT:
      return {
        ...state,
        assessmentCreationData: state.assessmentCreationData.filter(
          assessment => assessment.id !== action.assessmentId
        ),
        // Also remove any bulk upload data for this assessment
        bulkUploadData: Object.fromEntries(
          Object.entries(state.bulkUploadData || {}).filter(
            ([id]) => id !== action.assessmentId
          )
        ),
      }

    case CLEAR_ASSESSMENT_CREATION_DATA:
      return {
        ...state,
        assessmentCreationData: [],
      }

    case RESET_STATE:
      return INITIAL_STATE

    case SET_SUBSCRIPTION_STATES:
      return {
        ...state,
        subscriptionStates: action.states,
        error: null,
      }

    case SET_SUBSCRIPTION_CITIES:
      return {
        ...state,
        subscriptionCities: action.cities,
        error: null,
      }

    case SET_SUBSCRIPTION_INSTITUTES:
      return {
        ...state,
        subscriptionInstitutes: action.institutes,
        error: null,
      }

    case SET_CORPORATE_STATES:
      return {
        ...state,
        corporateStates: action.states,
        error: null,
      }

    case SET_CORPORATE_CITIES:
      return {
        ...state,
        corporateCities: action.cities,
        error: null,
      }

    case SET_CORPORATE_COMPANIES:
      return {
        ...state,
        companies: action.companies,
        error: null,
      }

    case ASSIGN_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        subscriptionAssignLoading: true,
        subscriptionAssignError: null,
        subscriptionAssignSuccess: null,
      }

    case ASSIGN_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptionAssignLoading: false,
        subscriptionAssignSuccess: action.message,
        subscriptionAssignError: null,
      }

    case ASSIGN_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        subscriptionAssignLoading: false,
        subscriptionAssignError: action.error,
        subscriptionAssignSuccess: null,
      }

    case SET_ASSESSMENT_CORPORATE_STATES:
      return {
        ...state,
        assessmentCorporateStates: action.states,
        error: null,
      }

    case SET_ASSESSMENT_CORPORATE_CITIES:
      return {
        ...state,
        assessmentCorporateCities: action.cities,
        error: null,
      }

    case SET_ASSESSMENT_CORPORATE_COMPANIES:
      return {
        ...state,
        assessmentCorporateCompanies: action.companies,
        error: null,
      }

    // Assessment States (KPI data)
    case FETCH_ASSESSMENT_STATES_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case FETCH_ASSESSMENT_STATES_SUCCESS:
      return {
        ...state,
        loading: false,
        completedAssessmentsMetrics: {
          ...state.completedAssessmentsMetrics,
          infoCards: action.payload.data || action.payload,
        },
      }

    case FETCH_ASSESSMENT_STATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // TPO Student List
    case FETCH_TPO_STUDENT_LIST_REQUEST:
      return {
        ...state,
        tpoStudentListLoading: true,
      }

    case FETCH_TPO_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        tpoStudentListLoading: false,
        tpoStudentList: action.payload.data ? (action.payload.data.students || []) : [],
        tpoStudentListPagination: {
          totalCount: action.payload.data ? (action.payload.data.totalCount || 0) : 0,
          pageNumber: action.payload.data ? (action.payload.data.pageNumber || 1) : 1,
          pageSize: action.payload.data ? (action.payload.data.pageSize || 10) : 10,
        },
      }

    case FETCH_TPO_STUDENT_LIST_FAILURE:
      return {
        ...state,
        tpoStudentListLoading: false,
        tpoStudentListError: action.payload,
      }

    // Chart filter handlers
    case SET_CHART_FILTERS:
      return {
        ...state,
        chartFilters: {
          ...state.chartFilters,
          ...action.payload,
        },
      }

    case CLEAR_CHART_FILTERS:
      return {
        ...state,
        chartFilters: {
          cefrLevel: null,
          aptitudeLevel: null,
          consistency: null,
          assessmentType: null,
        },
      }

    // Chart data action handlers
    case FETCH_ASSESSMENT_CHARTS_REQUEST:
      return {
        ...state,
        chartLoading: true,
        chartError: null,
      }

    case FETCH_ASSESSMENT_CHARTS_SUCCESS: {
      return {
        ...state,
        chartData: action.payload,
        chartLoading: false,
        chartError: null,
      }
    }

    case FETCH_ASSESSMENT_CHARTS_FAILURE:
      return {
        ...state,
        chartData: null,
        chartLoading: false,
        chartError: action.payload || action.error,
      }

    default:
      return state
  }
}

// Initial state for media availability
const MEDIA_INITIAL_STATE = {
  loading: false,
  mediaFiles: [],
  mediaUrls: { audio: null, video: null, audios: [], videos: [] },
  error: null,
  audioAvailable: false,
  videoAvailable: false,
  reportAvailable: false,
  checkingReportAvailability: false
}

// Reducer for handling media availability state
export const MediaState = (state = MEDIA_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MEDIA_KEYS_REQUEST:
      return {
        ...state,
        loading: true,
        // A Mix & Match report reuses this one reducer slot across its tabs.
        // Drop the previous assessment's files and signed URLs immediately so
        // no click can replay stale media while the new keys are loading.
        mediaFiles: [],
        mediaUrls: { audio: null, video: null, audios: [], videos: [] },
        audioAvailable: false,
        videoAvailable: false,
        error: null
      }

    case FETCH_MEDIA_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        mediaFiles: action.payload,
        audioAvailable: action.payload.some(file => file.type === 'audio'),
        videoAvailable: action.payload.some(file => file.type === 'video'),
        error: null
      }

    case FETCH_MEDIA_KEYS_FAILURE:
      return {
        ...state,
        loading: false,
        mediaFiles: [],
        mediaUrls: { audio: null, video: null, audios: [], videos: [] },
        audioAvailable: false,
        videoAvailable: false,
        error: action.payload
      }

    case FETCH_MEDIA_URLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case FETCH_MEDIA_URLS_SUCCESS:
      return {
        ...state,
        loading: false,
        mediaUrls: action.payload,
        error: null
      }

    case FETCH_MEDIA_URLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    // PDF Report availability actions  
    case CHECK_REPORT_AVAILABILITY_REQUEST:
      return {
        ...state,
        checkingReportAvailability: true,
        error: null
      }

    case CHECK_REPORT_AVAILABILITY_SUCCESS:
      return {
        ...state,
        checkingReportAvailability: false,
        reportAvailable: action.payload,
        error: null
      }

    case CHECK_REPORT_AVAILABILITY_FAILURE:
      return {
        ...state,
        checkingReportAvailability: false,
        reportAvailable: false,
        error: action.payload
      }

    case RESET_MEDIA_STATE:
      return MEDIA_INITIAL_STATE

    case SCHEDULE_ASSESSMENTS_REQUEST:
      return {
        ...state,
        isScheduling: true,
        scheduleError: null,
        scheduleSuccessMessage: '',
      };

    case SCHEDULE_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        isScheduling: false,
        scheduleSuccessMessage: action.payload,
      };

    case SCHEDULE_ASSESSMENTS_FAILURE:
      return {
        ...state,
        isScheduling: false,
        scheduleError: action.payload,
      };

    // Recalculation actions
    case RECALCULATE_ASSESSMENT_REQUEST:
      return {
        ...state,
        recalculating: true,
        recalculateError: null,
        recalculateSuccess: null,
      };

    case RECALCULATE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        recalculating: false,
        recalculateSuccess: action.payload,
        recalculateError: null,
      };

    case RECALCULATE_ASSESSMENT_FAILURE:
      return {
        ...state,
        recalculating: false,
        recalculateError: action.payload,
        recalculateSuccess: null,
      };

    case UPDATE_SCHEDULE_ASSESSMENT_REQUEST:
      return { ...state, isUpdatingSchedule: true, updateScheduleError: null };
    case UPDATE_SCHEDULE_ASSESSMENT_SUCCESS:
      return { ...state, isUpdatingSchedule: false, updateScheduleError: null };
    case UPDATE_SCHEDULE_ASSESSMENT_FAILURE:
      return { ...state, isUpdatingSchedule: false, updateScheduleError: action.payload };

    case GET_SCHEDULE_ASSESSMENT_REQUEST:
      return { ...state, isFetchingSchedule: true, fetchScheduleError: null, currentSchedule: null };
    case GET_SCHEDULE_ASSESSMENT_SUCCESS:
      return { ...state, isFetchingSchedule: false, currentSchedule: action.payload };
    case GET_SCHEDULE_ASSESSMENT_FAILURE:
      return { ...state, isFetchingSchedule: false, fetchScheduleError: action.payload };

    default:
      return state
  }
}
